// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__35V7M","resendInfoText":"OnGoingPaymentBox_resendInfoText__1hxB6"};